function serialize(key) {
  if (this[key] instanceof Date) {
    return {
      eval: 'date',
      apply: [this[key].getTime()],
    };
  }
  return this[key];
}

module.exports = serialize;
